import Cropper from "react-easy-crop";
import { useCallback, useState } from "react";
import { getCroppedImg } from "./CropImage";

function CropModal({ imageSrc, onClose, onCropDone }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [loading, setLoading] = useState(false);

  const onCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleDone = async () => {
    setLoading(true);
    const webpFile = await getCroppedImg(
      imageSrc,
      croppedAreaPixels
    );
    onCropDone(webpFile);
    setLoading(false);
    onClose();
  };

  return (
    <div style={overlay}>
      <div style={modal}>
        <h4>Crop Image (16:9)</h4>

        <div style={cropBox}>
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={16 / 9}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        </div>

        <input
          type="range"
          min={1}
          max={3}
          step={0.1}
          value={zoom}
          onChange={(e) => setZoom(e.target.value)}
        />

        <div style={actions}>
          <button onClick={onClose}>Cancel</button>
          <button onClick={handleDone} disabled={loading}>
            {loading ? "Processing..." : "Done"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CropModal;

/* Styles */
const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 999,
};

const modal = {
  background: "#fff",
  padding: 16,
  width: "90%",
  maxWidth: 500,
  borderRadius: 8,
};

const cropBox = {
  position: "relative",
  width: "100%",
  height: 250,
  marginTop: 10,
};

const actions = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  marginTop: 12,
};
